// extracted by mini-css-extract-plugin
export var controls = "log-formatter-module--controls--7012e";
export var field = "log-formatter-module--field--40598";
export var formatter = "log-formatter-module--formatter--d4f7b";
export var output = "log-formatter-module--output--cdb0e";
export var outputSelector = "log-formatter-module--outputSelector--0c862";